import React from 'react';
import HomeListManager from '../admincomponents/HomeListManager';

function AdminHomeBanners() {
  return (
    <HomeListManager
      title="Hero Banners"
      urlPath="home-banners"
      imageField="image"
      emptyMessage='No banners yet — click "Add" to create the first hero slide.'
      fields={[
        { name: 'mini_title', label: 'Mini Title', placeholder: 'e.g. Welcome to IFM Edu Academy!' },
        { name: 'title', label: 'Title', required: true, placeholder: 'e.g. Diploma in Facilities Management' },
        { name: 'description', label: 'Description', type: 'textarea', colClass: 'col-12' },
        { name: 'button_text', label: 'Button Text', placeholder: 'e.g. Free Consultation' },
        { name: 'button_link', label: 'Button Link', placeholder: 'e.g. /contacts' },
      ]}
    />
  );
}

export default AdminHomeBanners;
